import React from 'react'
import { motion, useAnimation, AnimatePresence } from "framer-motion";


const HamburgerIcon = ({toggle,setToggle,setHeaderToggle}) => {
  return (
    <AnimatePresence>
    {!toggle && <div
      onClick={() => {
        setToggle(true);
        setHeaderToggle(true);
      }}
      className="h-4 flex flex-col justify-between cursor-pointer"
    >
      <motion.div animate={{translateX:0,opacity:1}} initial={{translateX:-20,opacity:0}} transition={{duration:1,ease:"easeInOut"}} exit={{translateX:-20,delay:1,opacity:0}} className="w-10 h-px bg-customGray3"></motion.div>
      <motion.div animate={{translateX:0,opacity:1}} initial={{translateX:-30,opacity:0}} transition={{duration:1,ease:"easeInOut"}} exit={{translateX:-30,delay:1,opacity:0}} className="w-10 h-px bg-customGray3"></motion.div>
      <motion.div animate={{translateX:0,opacity:1}} initial={{translateX:-40,opacity:0}} transition={{duration:1,ease:"easeInOut"}} exit={{translateX:-40,delay:1,opacity:0}} className="w-10 h-px bg-customGray3"></motion.div>
    </div>}
  </AnimatePresence>
  )
}

export default HamburgerIcon